import React from "react"
import { Button } from "../ui/button"
import { SvgWarningSign } from "../icons"
import { useNavigate } from "react-router-dom"

const OverdueBanner: React.FC = () => {
  const navigate = useNavigate()

  return (
    <section className="w-full bg-[#FF4A00] text-white px-4 py-3 flex flex-wrap items-center justify-center gap-3 sm:gap-4 text-center sm:text-left z-50">
      <div className="flex items-center justify-center gap-2 flex-wrap max-w-[700px]">
        <SvgWarningSign className="w-5 h-5 flex-shrink-0" />
        <span className="text-sm sm:text-base font-medium leading-snug break-words">
          You have an overdue payment that needs attention. Please update your
          payment method or pay now.
        </span>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        <Button
          size="sm"
          onClick={() => navigate("/account-settings/payment-center")}
          className="bg-white text-[#FF4A00] hover:bg-[#FFE8E1] font-semibold"
        >
          View Payments
        </Button>
      </div>
    </section>
  )
}

export default OverdueBanner